import type { SummaryItem } from '../constants/changeOrderData';

interface SummaryStripProps {
  items: SummaryItem[];
}

const SummaryStrip = ({ items }: SummaryStripProps) => {
  return (
    <div className="coSummary">
      {items.map((item) => (
        <div className="summaryItem" key={item.label}>
          <p className="summaryLabel">{item.label}</p>
          <p className={`summaryValue ${item.tone || ""}`.trim()}>
            {item.value}
          </p>
          {item.sub ? <p className="summarySub">{item.sub}</p> : null}
        </div>
      ))}
    </div>
  );
};

export default SummaryStrip;
